<section class="approval-flow-page">
  <div class="page-heading">
    <div>
      <p>Master Configuration</p>
      <h1>Approval Flow</h1>
      <span>Define approval levels, approvers, and final authority for registration, outage, and other modules.</span>
    </div>
  </div>

  <div class="approval-grid">
    <form class="config-card flow-form" [formGroup]="form" (ngSubmit)="create()">
      <div class="card-heading">
        <h2>Create Approval Flow</h2>
        <p>Choose how many approval levels are required, then assign users level-wise.</p>
      </div>

      <label>
        <span>Module name</span>
        <input formControlName="module_name" placeholder="Registration, Outage, Scheduling">
      </label>

      <label>
        <span>Approval flow name</span>
        <input formControlName="flow_name" placeholder="Approval Flow Registration">
      </label>

      <label>
        <span>Description</span>
        <input formControlName="description" placeholder="Optional description">
      </label>

      <div class="form-row">
        <label>
          <span>No. of approval levels</span>
          <input type="number" min="1" max="20" formControlName="approval_levels" (change)="syncLevels()">
        </label>

        <label>
          <span>Final approval authority</span>
          <select formControlName="final_approval_authority_user_id">
            <option [value]="0">Select user</option>
            @for (user of users(); track user.id) {
              <option [value]="user.id">{{ user.full_name }} · {{ user.role?.name }}</option>
            }
          </select>
        </label>
      </div>

      <div class="level-section" formArrayName="levels">
        <div class="section-title">
          <h3>Level approvers</h3>
          <span>{{ levels.length }} levels</span>
        </div>

        @for (level of levels.controls; track level.value.level_no; let index = $index) {
          <div class="level-row" [formGroupName]="index">
            <strong>Level {{ index + 1 }}</strong>
            <input type="hidden" formControlName="level_no">
            <select formControlName="approver_user_id">
              <option [value]="0">Select approver</option>
              @for (user of users(); track user.id) {
                <option [value]="user.id">{{ user.full_name }} · {{ user.email }}</option>
              }
            </select>
          </div>
        }
      </div>

      <button type="submit" [disabled]="form.invalid">Create Approval Flow</button>

      @if (message) {
        <p class="form-message">{{ message }}</p>
      }
    </form>

    <div class="config-card flow-list">
      <div class="card-heading">
        <h2>Configured Flows</h2>
        <p>Reusable approval matrices for portal modules.</p>
      </div>

      @for (flow of approvalFlows(); track flow.id) {
        <article class="flow-item">
          <div>
            <strong>{{ flow.flow_name }}</strong>
            <span>{{ flow.module_name }} · {{ flow.approval_levels }} levels</span>
          </div>
          <em>{{ flow.final_approval_authority?.full_name || 'No final authority' }}</em>
          <ol>
            @for (level of flow.levels; track level.id) {
              <li>Level {{ level.level_no }}: {{ level.approver?.full_name || 'Unassigned' }}</li>
            }
          </ol>
        </article>
      } @empty {
        <div class="empty-state">No approval flows configured yet.</div>
      }
    </div>
  </div>
</section>
